<template>
  <div class="admin-dashboard">
    <div class="admin-header">
      <h1>{{ $t('legacy.Панель Администратора') }}</h1>
      <button @click="goToProjects" class="btn-back">{{ $t('legacy.Вернуться в ЛК') }}</button>
    </div>

    <div class="admin-nav">
      <router-link to="/admin/categories" class="nav-item">{{ $t('legacy.Категории') }}</router-link>
      <router-link to="/admin/elements" class="nav-item">{{ $t('legacy.Элементы') }}</router-link>
      <router-link to="/admin/backgrounds" class="nav-item">{{ $t('legacy.Фоны') }}</router-link>
      <router-link to="/admin/users" class="nav-item">{{ $t('legacy.Пользователи') }}</router-link>
      <router-link to="/admin/settings" class="nav-item">{{ $t('legacy.Настройки') }}</router-link>
      <router-link to="/admin/logs" class="nav-item">{{ $t('legacy.Логи') }}</router-link>
      <router-link to="/admin/ambassadors" class="nav-item">{{ $t('legacy.Амбасадоры') }}</router-link>
      <router-link to="/admin/payments" class="nav-item">{{ $t('legacy.Платежи') }}</router-link>
    </div>

    <div class="admin-content">
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdminDashboard',
  methods: {
    goToProjects() {
      this.$router.push('/projects');
    }
  }
}
</script>

<style scoped lang="scss">
.admin-dashboard {
  min-height: 100vh;
  background: #f5f5f5;
}

.admin-header {
  background: #fff;
  padding: 20px 40px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;

  h1 {
    margin: 0;
    font-size: 24px;
    color: #333;
  }

  .btn-back {
    padding: 10px 20px;
    background: #007bff;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;

    &:hover {
      background: #0056b3;
    }
  }
}

.admin-nav {
  background: #fff;
  padding: 0 40px;
  display: flex;
  gap: 20px;
  border-bottom: 1px solid #ddd;

  .nav-item {
    padding: 15px 20px;
    text-decoration: none;
    color: #666;
    border-bottom: 3px solid transparent;
    transition: all 0.3s;

    &:hover {
      color: #333;
    }

    &.router-link-active {
      color: #007bff;
      border-bottom-color: #007bff;
    }
  }
}

.admin-content {
  padding: 40px;
  max-width: 1400px;
  margin: 0 auto;
}
</style>
